import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'mat-progression-bar',
  templateUrl: './progress.component.html',
  styleUrls: ['./progress.component.scss']
})
export class ProgressComponent implements OnInit {
  progressType : string = "indeterminate";
  @Input() show : boolean = false;

  constructor() { }

  ngOnInit() {
  }

}
